
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalSolarthermie from "../../modals/modal_solarthermie.tsx";
import ModalSolarthermieFuture from "../../modals/modal_solarthermie_future.tsx";
import { MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT_LABELS, MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW_LABELS } from "../../state/types.ts";

export default function MeasureWidgetSolarthermieFuture() {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties); //MUST EXIST FOR REACTIVITY TO WORK
  const solarthermie = useStore((state)=>state.solarthermie || "");
  const solarthermie_future = useStore((state)=>state.solarthermie_future || "");

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);

  if (solarthermie == "" && solarthermie_future == ""){
    return <></>;
  }
          const current = measure_lables[solarthermie] || MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT_LABELS[solarthermie] || "" ;
          const future = measure_lables[solarthermie_future] || MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW_LABELS[solarthermie_future] || "" ;
  return <Measure key={"measure-widget-solarthermie"} label={"Solarthermie"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalSolarthermieFuture/>:<ModalSolarthermie/>)}/>;
}
